import { useContext, useState } from "react";
import styled from "styled-components";
import { EssentialsDataContext } from "../../Contexts/EssentialsDataContext";
import { AnswersContext } from "../../Contexts/AnswerContext";
import { CheckBox } from "../../components/UI-KIT/CheckBox";
import { ButtonStyled } from "../../styles/GenericButton";
import { T } from "../../styles/Theme";
import { Text, Title } from "../../styles/Texts";
import TextValues from "../../TextValues/index.json";
import Select from 'react-select';
import LocationData from "../../LocationData/index.json";

interface IOption {
  value: string;
  label: string;
}

interface IRegion {
  region: string;
  comunas: string[];
}

export const ContactScreen = () => {
  const termsAndConditions = (
    <>
    <p>
      <a href="https://www.artebianca.cl/terminos-y-condiciones/" target="_blank" rel="noreferrer">Acepto las políticas</a>, 
      entregando consentimiento para uso de datos en campañas publicitarias y automatizaciones de ARTEBIANCA y partners asociados.
      </p>
    </>
  )

  const [, , screenNumber, setScreenNumber] = useContext(EssentialsDataContext);
  const [, setAnswers] = useContext(AnswersContext);
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState<IOption | null>(null);
  const [comuna, setComuna] = useState<IOption | null>(null);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedComuna, setSelectedComuna] = useState("");
  const [identification, setIdentification] = useState("");
  const [phoneWithouPrefix, setPhoneWithouPrefix] = useState("");


  const allStates = LocationData.regiones.map((region: IRegion) => ({
    value: region.region,
    label: region.region,
  }));

  const allComunas = state
    ? LocationData.regiones
        .find((region: IRegion) => region.region === state.value)
        ?.comunas.map((comuna) => ({
          value: comuna,
          label: comuna,
        })) || []
    : [];

  const checkEmailRegex = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  const checkPhoneRegex = (phone: string) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(\(\+?\d{1,3}\)[\s\-\.\*]?((\d[\s\-\.\*]?){6}(\d[\s\-\.\*]?){2})?|(\+?\d[\s\-\.\*]?){8,9}(\d[\s\-\.\*]?){2})$/
    return regex.test(String(phone).toLowerCase())
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setPhoneWithouPrefix(input);
    setPhone("+569" + input);
  }

  const nextScreen = () => {
    setScreenNumber(screenNumber + 1);
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setAnswers({
      email,
      name,
      phone,
      state: state?.value,
      county: comuna?.value,
      address: null,
      identification: identification
    });
    nextScreen();
  }

  const verifyRut = (fullRut: string) => {
    if (!/^\d{8,9}[0-9kK]$/.test(fullRut)) {
      return false;
    }
    
    const rut = fullRut.slice(0, -1);
    const dv = fullRut.slice(-1).toLowerCase();
    
    const dvCalculado = calculateValidatorDigit(parseInt(rut));
    return dvCalculado === dv;
  }
  
  const calculateValidatorDigit = (T: number) => {
    let M = 0, S = 1;
    for (; T; T = Math.floor(T / 10)) {
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
    }
    return S ? String(S - 1) : 'k';
  }

  return (
    <Container>
      <TitleStyled>
        {TextValues.sentences.emailTitle}
      </TitleStyled>
      <br/>
      <TextStyled>
        {TextValues.sentences.emailDescription}
      </TextStyled>
      <br />
      <form onSubmit={(e) => handleSubmit(e)}>
      <TextStyled>Nombre</TextStyled>
        <div className="inpuContainer">
          <InputContact
            placeholder="Pedro Perez"
            autoFocus={true}
            onChange={(e) => setName(e.target.value)}
          />
        {((name === "") || (name.length < 4)) &&  <p style={{"fontSize": 12, "color": "red"}}>Por favor ingrese un Nombre valido</p>}
        </div>
      <TextStyled>Correo electrónico</TextStyled>
        <div className="inpuContainer">
          <InputContact
            placeholder="ejemplo@mail.com"
            autoFocus={true}
            onChange={(e) => setEmail(e.target.value)}
          />
        {(!checkEmailRegex(email)) && (email !== "") && <p style={{"fontSize": 12, "color": "red"}}>Por favor ingrese un email valido</p>}
        </div>
        <TextStyled>Teléfono</TextStyled>
        <div className="inpuContainer">
          <PhoneContainer>
            <Prefix>+569</Prefix> 
            <InputStyledPhone
              placeholder = "12345678"
              maxLength={8}
              value={phoneWithouPrefix}
              onChange={handlePhoneChange}
            />
          </PhoneContainer>
          {(!checkPhoneRegex(phone)) && phoneWithouPrefix  && <p style={{"fontSize": 12, "color": "red", 'paddingBottom': '10px'}}>Por favor ingrese un teléfono válido</p>}
        </div>
        <TextStyled>Región</TextStyled>
      <div className="inpuContainer">
      <div style={{ marginTop: 8 }} />
        <Select
          value={state}
          onChange={(selectedOption) => {
            setState(selectedOption as IOption);
            setComuna(null);
            setSelectedRegion((selectedOption as IOption).value);
          }}
          options={allStates}
          styles={customStyles}
          placeholder="Seleccione una región..."
        />
      </div>
      <div style={{'marginTop': 10}}></div>
      <TextStyled>Comuna</TextStyled>
      <div className="inpuContainer">
      <div style={{ marginTop: 8 }} />
        <Select
          value={comuna}
          onChange={(selectedOption) => {
            setComuna(selectedOption as IOption)
            setSelectedComuna((selectedOption as IOption).value);
          }}
          options={allComunas}
          styles={customStyles}
          placeholder="Seleccione una comuna..."
          isDisabled={!state}
        />
      </div>
        <br />
        <TextStyled>RUT (Opcional)</TextStyled>
        <div className="inpuContainer">
          <InputContact
            placeholder="123456789"
            onChange={(e) => setIdentification(e.target.value)}
          />
        {(!verifyRut(identification)) && (identification !== "") && <p style={{"fontSize": 12, "color": "red"}}>Por favor ingrese un RUT válido. El mismo no debe contener guiones ni puntos. <br/>Ejemplo: 123456780</p>}
        </div>
        <div>
        <CheckBox
          id={"termsAndConditions"}
          checked={checked}
          name={"termsAndConditions"}
          text={termsAndConditions}
          tag={""}
          onClick={() => setChecked(!checked)}
        />
        </div>
        <br />
        <div className="buttonContainer">
          <ButtonContactStyled
            bc={T.primary}
            c="white"
            disabled={!checkEmailRegex(email) || !checked || !checkPhoneRegex(phone) || name === "" || name.length < 4 || !selectedRegion || !selectedComuna}
          >
            Quiero continuar
          </ButtonContactStyled>
        </div>
        <SkipContainer>
          {/* <SkipStyled onClick={nextScreen}>Omitir</SkipStyled> */}
        </SkipContainer>
      </form>
    </Container>
  );
}

export default ContactScreen;

const customStyles = {
  control: (provided: any) => ({
    ...provided,
    borderColor: `${T.primary}`,
    '&:hover': {
      borderColor: `${T.primary}`,
    },
    boxShadow: 'none'
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected ? 'white' : 'black',
    backgroundColor: state.isSelected ? `${T.primary}` : 'white',
    '&:hover': {
      backgroundColor: `${T.primary}`,
      color: 'white',
    },
  }),
  singleValue: (provided:any) => ({
    ...provided,
    color: 'black',
  })
};


const TitleStyled = styled(Title)`
  margin: 30px 0 5px 0;

  @media(max-width: 480px) {
    font-weight: ${T.fontWeights.bold}
  }
`;

const TextStyled = styled(Text)`
  padding: 0 20px 0px 20px;
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  max-width: 520px;
  margin: auto;
  .buttonContainer {
    margin: 10px auto 5px;
    max-width: 180px;
  }
  .inpuContainer {
    padding: 0 20px 0px 20px;
    width: 100%;
  }
`;

// InputContact centered
const InputContact = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid ${T.gray};
  border-radius: 5px;
  padding: 0 10px;
  font-size: ${T.fontSizes.small};
  outline: none;
  margin: 10px auto;
  &:focus {
    border: 1px solid ${T.primary};
  }
`;

const SkipStyled = styled.span`
  font-size: 12px;
  color: black;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
    color: ${T.primary}
  }
`;

const SkipContainer = styled.div`
  margin: 0 auto 10px;
  max-width: 30px;
  padding: 0;
  align-items: center;
}
`;

const ButtonContactStyled = styled(ButtonStyled)`
  border-radius: ${T.borderRadius.button};

  &:disabled {
    background: rgb(176, 176, 176);
  }
`;

const PhoneContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Prefix = styled.span`
  background-color: ${T.gray};
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid ${T.gray};
  border-right: none;
`;

const InputStyledPhone = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid ${T.gray};
  border-radius: 5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 10px;
  font-size: 16px;
  outline: none;
  margin: 5px auto;
  &:focus {
    border: 1px solid ${T.primary};
  }
`;